import { createElement, styled, compose, position, layout, flexbox, space, color, typography, border, opacity, listStyle, cursor } from '@vebox/etui-system';

const LiElement = createElement('li');
const Li = styled(LiElement)(compose(position, layout, flexbox, space, color, typography, border, opacity, listStyle, cursor));

export { Li };
